document.addEventListener("DOMContentLoaded", function() {
  var toggleButtons = document.querySelectorAll(".js-addAddress-toggle");
  var form = document.getElementById("addAddressForm");

  toggleButtons.forEach(function(button) {
    button.addEventListener("click", function() {
      form.style.display = (form.style.display === "block") ? "none" : "block";
    });
  });

  // 編集ボタンとキャンセルボタンのクリックイベントを監視
  var buttons = document.querySelectorAll('.p-account__mypage-address-edit button[aria-controls], .p-account__address-cancel button[aria-controls]');

  buttons.forEach(function(button) {
    button.addEventListener("click", function() {
      // aria-controls属性から対象のIDを取得
      var targetId = button.getAttribute('aria-controls');
      var targetElement = document.getElementById(targetId);

      // トグル処理：表示されていれば非表示、非表示なら表示にする
      if(targetElement.style.display === "none" || targetElement.style.display === "") {
        targetElement.style.display = "block";
      } else {
        targetElement.style.display = "none";
      }
    });
  });
});
